import { dmpCommandSuccessContextualizedType } from "dmpconnectjsapp-base/actions";
import { apiSections }                         from "dmpconnectjsapp-base/constants";
import merge                                   from "lodash.merge";
import { dmpconnectApplicationActionConstants } from "../constants";
import { extractPersistantDataFromSectionAndDecode } from "../helpers/persistantData";
import { objectWithoutTheseKeys } from "../utils/dataUtils";
export const PERSISTANT_DATA_VERSION = 1;

const initialState = {
  efficience: {
    version: PERSISTANT_DATA_VERSION
  }
};

export function persistantData(state = initialState, action) {
  switch (action.type) {
    case dmpCommandSuccessContextualizedType(apiSections.CLEAR_PERSISTANT_DATA):
      return initialState;
    case dmpCommandSuccessContextualizedType(apiSections.GET_PERSISTANT_DATA): {
      console.debug('debug - save persistant data', action)
      const persistantDataFromSection =
        extractPersistantDataFromSectionAndDecode(action.data || {});
      console.debug(
        "debug - persistantDataFromSection",
        persistantDataFromSection
      );
      return merge({}, initialState, persistantDataFromSection);
    }
    case dmpconnectApplicationActionConstants.HANDLE_SET_PERSISTANT_DATA: {
      const { data } = action;
      return merge({}, initialState, objectWithoutTheseKeys(data, ['_persist', 'callId', 'reason']));
    }
    default:
      return state;
  }
}
